<template>
  <div class="content">
    <div class="back" @click="back">
      <img src="@/assets/icons/icon_fh.png" alt="" srcset="">
      <span>{{ $t('back') }}</span>
    </div>
    <div class="headers">
      <div class="tabs">
        <a-button
          type="primary"
          :class="[currentType === 'course' ? 'active' : 'default']"
          @click="changeType('course')"
          >{{ $t('lesson.course') }}</a-button
        >
        <a-button
          type="primary"
          :class="[currentType === 'guidance' ? 'active' : 'default']"
          @click="changeType('guidance')"
          >{{ $t('lesson.guidance') }}</a-button
        >
      </div>
      <a-form layout="inline" class="l-form">
        <a-form-item label="" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol">
          <a-range-picker
            v-model="dateRange"
            format="YYYY-MM-DD"
            :placeholder="[$t('datePicker.startDate'), $t('datePicker.endDate')]"
            @change="onChange"
          >
            <a-icon slot="suffixIcon" type="down" style="color: #ccc" />
          </a-range-picker>
        </a-form-item>
      </a-form>
    </div>
    <div class="list">
      <a-table :columns="columns" :data-source="list" :locale="locale" @change="handerChange">
        <template slot="name" slot-scope="text, record">
          <a-tooltip class="lesson-name">
            <template slot="title">
              {{ record.name }}
            </template>
            {{ record.name }}
          </a-tooltip>
        </template>
        <template slot="guidanceType" slot-scope="text, record">
          {{
            record.guidanceType === '1'
              ? $t('lesson.guidanceType.public')
              : record.guidanceType === '2'
              ? $t('lesson.guidanceType.scheduledPublic')
              : record.guidanceType === '3'
              ? $t('lesson.guidanceType.private')
              : $t('lesson.guidanceType.challenge')
          }}
        </template>
        <template slot="operate" slot-scope="text, record">
          <a-button v-if="currentType === 'course'" type="link" style="color: #5B7499" @click="lessonReports(record)"
            >{{ $t('operations.classReport') }}</a-button
          >
          <template v-if="currentType === 'guidance'">
            <a-button
              type="link"
              style="color: #5B7499"
              :disabled="record.status !== '1'"
              @click="editGuidance(record)"
            >
              {{ $t('operations.edit') }}
            </a-button>
            <a-button type="link" style="color: #5B7499" @click="lessonReports(record)">{{ $t('lesson.guidanceReport') }}</a-button>
          </template>
          <a-button
            type="link"
            style="color: #5B7499"
            :disabled="record.status === '2'"
            @click="lessonDelModal(record.id)"
          >
          {{ $t('operations.delete') }}
          </a-button>
        </template>
      </a-table>
      <Pagination class="list-pagination" :pagination.sync="pagination" @handleTableChange="handleTableChange" />
    </div>
    <TipModal
      @ok="del"
      :visible="delVisible"
      @cancel="delVisible = false"
      :desc="`
        <p>${$t('deleteConfirm.titleLesson')}</p>
        <p class='placeholder'>${$t('deleteConfirm.warning')}</p>`" />
  </div>
</template>
<script>
import { lessonDel, classMap, lessonList, prepareLessonList, guidanceList, guidanceDel } from '@/api/lesson'
import { getListIndex } from '@/utils/other'
import TipModal from '@/components/tipModal/index.vue'
import Pagination from '@/components/pagination/index.vue'
import Empty from '@/components/Empty/index.vue'

export default {
  components: {
    TipModal,
    Empty,
    Pagination
  },
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 7 },
        wrapperCol: { span: 17 }
      },
      dateRange: [],
      classId: undefined,
      status: undefined,
      minute: {
        time: undefined,
        minute: 0
      },
      delId: undefined,
      delVisible: false,
      keyword: undefined,
      playVisible: false,
      list: [],
      columns: [
        {
          title: this.$t('table.id'),
          key: 'index',
          align: 'center',
          dataIndex: 'index'
        },
        {
          title: this.$t('table.courseName'),
          key: 'name',
          align: 'center',
          dataIndex: 'name',
          filterMultiple: false,
          filteredValue: [],
          filterIcon: filtered => {
            if (filtered) {
              return <img style="width: 1.1em; height: 1.1em" src={require('@/assets/icons/icon_zt_x.png')} />
            }
            return <img style="width: 1.1em; height: 1.1em" src={require('@/assets/icons/icon_zt.png')} />
          },
          filters: []
        },
        {
          width: 120,
          title: this.$t('table.class'),
          key: 'className',
          align: 'center',
          dataIndex: 'className',
          filterMultiple: false,
          filterIcon: filtered => {
            if (filtered) {
              return <img style="width: 1.1em; height: 1.1em" src={require('@/assets/icons/icon_zt_x.png')} />
            }
            return <img style="width: 1.1em; height: 1.1em" src={require('@/assets/icons/icon_zt.png')} />
          },
          filters: []
        },
        {
          align: 'center',
          title: this.$t('table.startTime'),
          key: 'startTime',
          dataIndex: 'startTime',
          sorter: (a, b) => a.startTime - b.startTime
        },
        {
          align: 'center',
          title: this.$t('table.endTime'),
          key: 'endTime',
          dataIndex: 'endTime',
          sorter: (a, b) => a.endTime - b.endTime
        },
        {
          width: 240,
          align: 'center',
          title: this.$t('table.operations'),
          key: 'operate',
          dataIndex: 'operate',
          scopedSlots: { customRender: 'operate' }
        }
      ],
      pagination: {
        page: 1,
        total: 0,
        pageSize: 10
      },
      prepareLessonList: [],
      prepareLessonId: undefined,
      text: this.$t('emptyText.noReport'),
      desc: this.$t('emptyText.tryOtherTime'),
      locale: {
        emptyText: () => <Empty text={this.text} desc={this.dateRange.length > 0 ? this.desc : ''} margin="100" />
      },
      currentType: 'course'
    }
  },
  methods: {
    back() {
      this.$router.push({
        name: 'myCourses'
      })
    },
    onSearch() {
      this.pagination.page = 1
      this.getLessonList()
    },
    onChange() {
      this.pagination.page = 1
      this.getLessonList()
    },
    handleTableChange() {
      // this.pagination.page = pagination.current
      this.getLessonList()
    },
    handerChange(pagination, filters, sort) {
      console.log(filters, sort)
      this.pagination.page = 1
      this.classId = filters.className && filters.className.length > 0 ? filters.className[0] : undefined
      this.status = filters.status && filters.status.length > 0 ? filters.status[0] : undefined
      this.prepareLessonId = filters.name && filters.name.length > 0 ? filters.name[0] : undefined
      this.columns[1].filteredValue = filters.name
      this.sortField = sort.field === 'startTime' ? 'start_time' : sort.field === 'endTime' ? 'end_time' : null
      this.sortRule = sort.order === 'ascend' ? 'asc' : sort.order === 'descend' ? 'desc' : null
      this.guidanceType = filters.guidanceType && filters.guidanceType.length > 0 ? filters.guidanceType[0] : undefined
      this.getLessonList()
    },

    lessonAdd() {
      this.$router.push({
        name: 'lessonAdd'
      })
    },
    lessonEdit(id) {
      this.$router.push({
        name: 'lessonAdd',
        query: {
          id
        }
      })
    },
    lessonDelModal(id) {
      this.delVisible = true
      this.delId = id
    },
    del() {
      if (this.currentType === 'course') {
        lessonDel({ id: this.delId }).then(res => {
          if (res.code != 200) return
          this.delVisible = false
          this.$message.success(this.$t('messages.deleteSuccess'))
          this.pagination.page = 1
          this.getLessonList()
        })
      } else {
        guidanceDel({ id: this.delId }).then(res => {
          if (res.code != 200) return
          this.delVisible = false
          this.$message.success(this.$t('messages.deleteSuccess'))
          this.pagination.page = 1
          this.getLessonList()
        })
      }
    },
    lessonReports(record) {
      this.$router.push({
        name: this.currentType === 'course' ? 'lessonReports' : 'guidanceReports',
        query: {
          id: record.id,
          name: record.name,
          guidanceType: record.guidanceType
        }
      })
    },
    getClassMap() {
      const that = this
      classMap().then(res => {
        that.columns[2].filters = res.data.list.map(item => {
          return {
            text: item.name,
            value: item.id
          }
        })
      })
    },
    async getPrepareLessonList() {
      const data = {
        pageSize: 0
      }
      const res = await prepareLessonList(data)
      this.columns[1].filters = res.data.list.map(item => {
        return {
          text: item.name,
          value: item.id
        }
      })
    },
    getLessonList() {
      const data = {
        classId: this.classId,
        startTime:
          this.dateRange && this.dateRange.length > 0
            ? this.dateRange[0].format('YYYY-MM-DD') + ' 00:00:00'
            : undefined,
        endTime:
          this.dateRange && this.dateRange.length > 0
            ? this.dateRange[1].format('YYYY-MM-DD') + ' 23:59:59'
            : undefined,
        status: this.status,
        prepareLessonId: this.prepareLessonId,
        sortField: this.sortField,
        sortRule: this.sortRule,
        page: this.pagination.page,
        guidanceType: this.guidanceType
      }
      if (this.currentType === 'course') {
        lessonList(data).then(res => {
          if (res.code != 200) return
          this.list = getListIndex(res.data.list, this.pagination.page, this.pagination.pageSize)
          this.pagination.total = Number(res.data.total)
        })
      } else {
        data.lessonId = this.prepareLessonId
        delete data.prepareLessonId
        guidanceList(data).then(res => {
          if (res.code != 200) return
          this.list = getListIndex(res.data.list, this.pagination.page, this.pagination.pageSize)
          this.list = this.list.map(item => ({
            ...item,
            name: item.lessonName,
            status: item.status
          }))
          this.pagination.total = Number(res.data.total)
        })
      }
    },
    changeType(type) {
      this.currentType = type
      if (type === 'guidance') {
        this.columns.splice(3, 0, {
          width: 150,
          title: this.$t('lesson.guidanceType.title'),
          key: 'guidanceType',
          align: 'center',
          dataIndex: 'guidanceType',
          filterMultiple: false,
          filterIcon: filtered => {
            if (filtered) {
              return <img style="width: 1.1em; height: 1.1em" src={require('@/assets/icons/icon_zt_x.png')} />
            }
            return <img style="width: 1.1em; height: 1.1em" src={require('@/assets/icons/icon_zt.png')} />
          },
          filters: [
            {
              value: '1',
              text: this.$t('lesson.guidanceType.public')
            },
            {
              value: '2',
              text: this.$t('lesson.guidanceType.scheduledPublic')
            },
            {
              value: '3',
              text: this.$t('lesson.guidanceType.private')
            },
            {
              value: '4',
              text: this.$t('lesson.guidanceType.challenge')
            }
          ],
          scopedSlots: { customRender: 'guidanceType' }
        })
      } else {
        this.columns.splice(3, 1)
      }
      this.getLessonList()
    },
    editGuidance(record) {
      this.$router.push({
        name: 'tutorialRelease',
        query: {
          id: record.lessonId,
          guidanceId: record.id
        }
      })
    }
  },
  mounted() {
    this.prepareLessonId = this.$route.query.id
    this.columns[1].filteredValue = [this.prepareLessonId]
    this.getClassMap()
    this.getPrepareLessonList()
    this.getLessonList()
  }
}
</script>

<style lang="less" scoped>
.content {
  padding: 20px;
  /deep/ .ant-btn-link[disabled] {
    color: rgba(0, 0, 0, 0.25) !important;
  }
  .back {
    width: 80px;
    height: 34px;
    display: flex;
    cursor: pointer;
    font-size: 14px;
    font-weight: 400;
    color: #000000;
    border-radius: 25px;
    align-items: center;
    justify-content: center;
    border: 1px solid #d6d6d6;
    img {
      height: 10px;
      margin-right: 9px;
    }
  }
  .headers {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 15px auto;
  }
  /deep/ .l-form {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .ant-input,
    .ant-input-affix-wrapper {
      width: 237px;
      height: 35px;
      color: #000;
      margin-right: 30px;
      border-radius: 20px;
      .ant-input-prefix,
      .ant-input-suffix {
        > img {
          width: 16px;
          cursor: pointer;
        }
      }
      .ant-input-suffix .clear {
        width: 14px;
        height: 14px;
      }
    }
    .ant-form-item {
      margin-bottom: 0 !important;
      width: 250px;
      line-height: 30px;
    }
    .ant-form-item-label {
      margin-top: 10px;
    }
  }
}
.tabs {
  background-color: #edf3fa;
  width: 120px;
  border-radius: 30px;
  display: flex;
  .active {
    box-shadow: none;
    width: 60px;
    color: #fff !important;
    background: linear-gradient(248deg, #ff6d00 0%, #f5a623 100%) !important;
  }
  /deep/ .ant-btn {
    border-radius: 20px !important;
    &:hover {
      background: #edf3fa;
      color: #6b738c !important;
    }
  }
  .default {
    box-shadow: none;
    width: 60px;
    background: #edf3fa;
    color: #6b738c !important;
  }
}
.list {
  height: calc(100% - 104px);
  color: #000;
  margin: 12px 0px 0;
  position: relative;
  .ant-table-wrapper {
    overflow-y: auto;
    height: calc(100% - 50px);
  }
  .ant-btn {
    padding: 0px 5px;
  }
  // .ant-table-wrapper::-webkit-scrollbar{
  //   display: none;
  // }
  .list-pagination {
    width: 100%;
    height: auto;
    bottom: 40px;
    position: absolute;
  }
}

.header {
  // width: calc(100% - 107px);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  padding: 46px 28px 22px 19px;
  justify-content: space-between;
  /deep/.ant-input-group-wrapper {
    width: 330px;
    height: 35px;
    .ant-input-prefix {
      // right: auto;
      left: 16px;
      img {
        width: 16px;
      }
    }
    .ant-input-suffix {
      right: 0;
      .anticon.anticon-close-circle.ant-input-clear-icon {
        display: none;
      }
      .clear {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
    }
    .ant-input-search {
      height: 35px;
      .ant-input {
        height: 35px;
        padding-left: 46px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        border-color: #d8dce0;
        box-shadow: none;
      }
    }
    .ant-input-group-addon .search-btn {
      border-left: 0;
      height: 35px;
      border-color: #d8dce0;
      border-top-right-radius: 20px;
      border-bottom-right-radius: 20px;
      span {
        display: flex;
        font-size: 14px;
        color: #333333;
        position: relative;
        align-items: center;
        &::before {
          left: -8px;
          content: '';
          width: 1px;
          height: 15px;
          background: #e9e9e9;
          position: absolute;
        }
      }
    }
    // border: 1px solid #D8DCE0;
  }
}
.nodata {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 50vh;
  transform: translateY(-200px);
  img {
    width: 285px;
    margin-bottom: 12px;
  }
  > div {
    width: 100%;
    display: flex;
    margin-top: -48px;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    .text {
      font-weight: 550;
      color: #0d2340;
      margin-bottom: 10px;
    }
  }
}
.lesson-name {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  word-break: break-all;
  text-overflow: ellipsis;
}
/deep/.ant-btn,
/deep/.ant-table,
/deep/.ant-input {
  color: #000;
}
/deep/.ant-modal-body {
  color: #000;
  padding: 50px;
  text-align: center;
  p:first-child {
    font-size: 16px;
  }
}
/deep/.ant-dropdown-menu-item {
  width: 86px;
  height: 30px;
  display: flex;
  font-size: 12px;
  margin: 7px 8px;
  font-weight: 400;
  line-height: 17px;
  align-items: center;
  border-radius: 15px;
  background: #f8f8f8;
  //  !important;
  img {
    width: 12px !important;
    margin-right: 6px;
  }
  span {
    width: 100%;
    color: #384959;
    display: inline-block;
    text-align-last: justify;
  }
  &:hover span {
    color: #ff6d00;
  }
}
.ant-dropdown-menu-item.ant-dropdown-menu-item-disabled:hover span {
  color: #384959;
}
/deep/.ant-btn-default,
.ant-dropdown-trigger {
  border: 0;
  color: #5b7499;
  box-shadow: none;
  background: none;
  padding-right: 6px;
  .anticon.anticon-ellipsis {
    transform: rotate(90deg);
  }
}
/deep/.ant-dropdown-trigger {
  width: 22px;
  height: 22px;
  color: #333333;
  padding: 0 0 1px 0 !important;
}
/deep/.ant-dropdown-trigger {
  right: 20px !important;
}
/deep/.operate {
  .ant-dropdown-trigger {
    right: 0 !important;
  }
  .ant-dropdown-trigger.ant-dropdown-open {
    background: #e6e6e6;
    right: 0 !important;
    border-radius: 100% !important;
    // border: 1px solid #FF6D00;
  }
}
/deep/ .ant-table-placeholder {
  padding: 0;
}
</style>
